const WEBSITES = {
  PAGE_TITLE: 'Dashboard | Raychat',

  HEADING_TITLE: 'Websites',
  WELCOME: 'Welcome',
  HEADING_SUBTITLE:
    'Here, while viewing the list of sites, you can get the code snippet for each site, enable or disable the Raychat widget, assign operators and access the conversation archive.',
  HONOR_TEXT: 'We hope to be able to have the honor of serving you dear users',
  DASHBOARD_HELP: 'Dashboard Help',
  ADD_WEBSITE: 'Add Website',
  SEE_ALL_WEBSITES: 'Show All',

  CUSTOMIZATION: 'Customization',
  DELETE_WEBSITE: 'Delete Website',
  CHOOSE_WEBSITE: 'Choose Website',

  DASHBOARD_NAME: 'Dashboard',
  PACKAGE_TYPE: 'Your Package Type',
  REMAINING_CHARGE: 'Remaining Charge',
  REMAINING_SERVICE: 'Remaining Service',
  REVIVE_SERVICE: 'Extend the service',
  SERVICE_END: 'Service Ended',
  EXPIRE_SOON:
    'Your service will end in #days# days. Please renew to use Raichat facilities. Thank you!',
  SERVICE_END_DESC:
    'Your service has ended. Please renew to use Raychat facilities. Thank you!',
  DAY: 'Days',
  MESSAGE: 'Messages',
  WEBSITE_WORD: 'Website',

  GENERAL_STATISTICES: 'General Statistics',
  WORKSPACES_N: 'Number Of Websites',
  COMING: 'Coming Soon...',
  USERS_N: 'Number Of All Users',
  CONVERSATIONS_N: 'Number Of All Conversations',
  OPERATORS_N: 'Number Of Operators',

  ALL_CONVS: 'Conversations',
  ALL_USERS: 'Users',
  CONVERSION_RATE: 'Conversion Rate',

  ACTIVE: 'active',
  INACTIVE: 'inactive',

  // WebsiteListMain

  // WebsiteItemHeader
  SETTINGS: 'Settings',
  ASSIGN_OPERATOR: 'Assign Operator',
  ARCHIVES: 'Archives',

  // WebsiteItemOperators
  OPERATORS: 'Operators',
  THERE_IS_NO_OPERATOR: 'No operator has been assigned to this website.',

  // WebsiteItemWidget
  INSTALL_SCRIPT_NOT_FOUND: 'There is no installation code in this website',
  INSTALL_INSTRUCTION: 'Please place the script before ending #head# tag',
  GET_SCRIPT: 'Get Install Script',
  THERE_IS_NO_DATA: 'No statistics have been recorded.',

  // AcceptedConversationsChart
  ACCEPTED_CONVERSATIONS: 'Accepted',
  CLOSED_CONVERSATIONS: 'Closed',
  CLOSED_AGENT_CONVERSATION: 'Unanswered',
  DENIED_CONVERSATION: 'Rejected',
  TODAY: 'Today',

  MODAL: {
    // InstallWidgetModal
    INSTALL_WIDGET_TITLE: 'Installing widget script on website',
    INSTALL_WIDGET_SUBTITLE_TITLE:
      'Please add the script before ending #head# tag.',
    INSTALL_WIDGET_COPY_CODE: 'Copy the code',

    // AddWebsiteModal
    ADD_WEBSITE_TITLE: 'Add New Website',
    ADD_WEBSITE_FORM_TITLE: 'Website Title',
    ADD_WEBSITE_FORM_ADDRESS: 'Website Address: example.com',
    ADD_WEBSITE_FORM_ADD_ALL: 'Add All Operators',
    ADD_WEBSITE_FOOTER_CONFIRM: 'Add Website',

    // AssignOperatorsModal
    ASSIGN_OPERATOR_TITLE: 'Assign/Unassigning Operator',
    ASSIGN_OPERATOR_SEARCH: 'Search Operator',
    ASSIGN_OPERATOR_OPERATORS: 'Operators',
    ASSIGN_OPERATOR_OPERATOR: 'Operator',
    ASSIGN_OPERATOR_HINT:
      'To assign an operator to the site or not to assign it, click on the avatar.',

    CLOSE: 'Close',
    CANCEL: 'Cancel',
    SAVE: 'Save',
  },
  DELETE_TITLE: 'Delete Website',
  DELETE_DESC: 'Are you sure you want to delete this website?',
  DELETE_CONFIRMATION_BTN: 'Submit',
  DELETE_CANCEL_BTN: 'No',
  DISABLE_DELETE_TOOLTIP: 'You need to upgrade your package: ',
  BUY_PACKAGE: 'Buy',
  POPULAR: 'Popular',
  SPECIAL_DISCOUNT_FOR_NEW_BUSINESS: 'Special Discount for new businesses',
};

export default WEBSITES;
